fragment recordingBlobDetails on RecordingBlobType {
  ok
  errors
  id
  length
  filename
  blob
}
